import CarouselImage from './CarouselImage';

export default CarouselImage;
